import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient.js';
import SponserRow from './SponserRow.jsx';
import { DEFAULT_CONFERENCE_ID, useStateContext } from '../../Contexts/ContextProvider.jsx';
import Loader from '../../assets/tools/Loder/loader';

const Sponsers = () => {
  const [sponsors, setSponsors] = useState([]);
  const { SetNotification } = useStateContext();
  const [loading, setLoading] = useState(true);
  const [conferenceId, setConferenceId] = useState(DEFAULT_CONFERENCE_ID);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await AxiosClient.get(`/conference/${conferenceId}/sponsors`);
        setSponsors(response.data);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
        SetNotification('Error fetching data', 'danger');
      } finally {
        setLoading(false);
      }
    };
    if (conferenceId)
      fetchData();

  }, [conferenceId]);

  const handleDeleteSponsor = async (id) => {
    try {
      await AxiosClient.delete(`/sponsors/${id}`);
      setSponsors(sponsors.filter(sponsor => sponsor.id !== id));
      SetNotification('A sponsor has been deleted', 'success');
    } catch (error) {
      console.error(error);
      SetNotification('Error while deleting the sponsor', 'danger');
    }
  };

  return (
    <section>
      {
        conferenceId && <>


          <div className="m-3">
            <Link className="btn btn-dark m-2" to={`./Add/${conferenceId}`}>
              <i className="material-icons">add_box</i> | Add a new sponsor
            </Link>

          </div>
          <div className="card-body px-0 pb-2">
            <div className="p-0 text-center">
              {loading ? <Loader label="Loading sponsors..." /> :
                <>
                  {sponsors && sponsors.length > 0 ?
                    <table className="table align-items-center justify-content-center mb-0">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Logo</th>
                          <th>Website</th>
                          <th>Type</th>
                          <th>Active</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sponsors.map(sponsor => (
                          <SponserRow
                            key={sponsor.id}
                            name={sponsor.name}
                            description={sponsor.description}
                            logo={sponsor.logo}
                            website={sponsor.website}
                            type={sponsor.type}
                            active={sponsor.active}
                            id={sponsor.id}
                            onDelete={handleDeleteSponsor}
                          />
                        )) }
                      </tbody>
                    </table> : <h5 className='text-danger p-2'> no Sponsers for the selected conference </h5>}
          </>
              } 
            </div>
          </div>

        </>
      }
    </section>

  );
};

export default Sponsers;
